import httpClient from "Api/httpClient";

const END_POINT = "/sql/tables";

const getSqlTables = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getSqlTable = (table_id) => {
    if (!table_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + table_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printSqlTable = (table_id) => {
    if (!table_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?table_id=" + table_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createSqlTables = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateSqlTables = (payload, table_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + table_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteSqlTables = (table_id) => {
    const DELETE_END_POINT = END_POINT + "/" + table_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const getSqlSync = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const SYNC_END_POINT = "/sql/sync";
    return httpClient.get(SYNC_END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

export { getSqlTables, getSqlTable, printSqlTable, createSqlTables, updateSqlTables, deleteSqlTables, getSqlSync };
